import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKey,
  authDomain: process.env.REACT_APP_AuthDomain,
  projectId: process.env.REACT_APP_ProjectId,
  messagingSenderId: process.env.REACT_APP_MessagingSenderId,
  appId: process.env.REACT_APP_AppID,
  storageBucket: process.env.REACT_APP_StorageBucket,
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export const messages = getMessaging(app);

/* ---------------- Service Worker Registration ---------------- */

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`${process.env.REACT_APP_PUBLIC_URL}/firebase-messaging-sw.js`)
    .then((registration) => {
      // console.log("✅ Service Worker registered:", registration.scope);
    })
    .catch((error) => {
      // console.error("❌ Service Worker registration failed:", error);
    });
}

/* ---------------- Get FCM Token ---------------- */

export const getFcmToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    // ✅ Wait until the SW is ready
    const readyReg = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_Valid_Key,
      serviceWorkerRegistration: readyReg,
    });

    // console.log("🔥 FCM Token:", token);

    return token;
  } catch (error) {
    console.error("FCM token error:", error);
    return null;
  }
};

/* ---------------- Foreground Listener ---------------- */

export const listenForegroundMessages = (callback) => {
  onMessage(messaging, (payload) => {
    console.log("🔥 Foreground Message Received:", payload);

    if (callback) callback(payload);
  });
};
